import { render, staticRenderFns } from "./orderlist.vue?vue&type=template&id=2b4f75de&scoped=true&"
import script from "./orderlist.vue?vue&type=script&lang=js&"
export * from "./orderlist.vue?vue&type=script&lang=js&"
import style0 from "./orderlist.vue?vue&type=style&index=0&id=2b4f75de&less=true&scoped=true&lang=css&"
import style1 from "./orderlist.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4f75de",
  null
  
)

export default component.exports